import { FormikProps, getIn } from 'formik'
import { useEffect, useRef } from 'react'
import { OptionsHelper } from '_metronic/helpers'
import { FormSelect } from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import {
  getOptionsTiposLogradouro,
  getPaisBrasil,
  getRotuloTipoLogradouro,
} from './tipoLogradouroPais'

type IProps<V> = {
  formik: FormikProps<V>
  /** Prefixo dos campos no formik (`endereco.` ou vazio). */
  prefixo: string
  /** Endereço novo: país começa em Brasil. */
  novo: boolean
  idPrefix: string
}

export const TipoLogradouroPaisFields = <V,>({ formik, prefixo, novo, idPrefix }: IProps<V>) => {
  const { t } = useT()
  const { setFieldValue } = formik
  const campoPais = `${prefixo}pais`
  const paisAtual = getIn(formik.values, campoPais)
  const padraoAplicado = useRef(false)
  const campoTipo = `${prefixo}tipoLogradouro`
  const tipoAtual = getIn(formik.values, campoTipo)

  // O endereço gravado traz só o `name`; troca pelo rótulo do catálogo.
  useEffect(() => {
    if (!tipoAtual?.value || tipoAtual.label !== tipoAtual.value) return
    getRotuloTipoLogradouro(tipoAtual.value)
      .then((label) => setFieldValue(campoTipo, { value: tipoAtual.value, label }))
      .catch(() => {})
  }, [tipoAtual, campoTipo, setFieldValue])

  useEffect(() => {
    if (!novo || paisAtual || padraoAplicado.current) return
    padraoAplicado.current = true
    getPaisBrasil()
      .then((brasil) => {
        if (brasil) setFieldValue(campoPais, brasil)
      })
      .catch(() => {})
  }, [novo, paisAtual, campoPais, setFieldValue])

  return (
    <div className='row mb-3'>
      <div className='col-md-6'>
        <FormSelect
          formik={formik}
          name={campoTipo}
          inputId={`${idPrefix}-tipoLogradouro`}
          label={t('tipo_logradouro.label')}
          fetchOptions={getOptionsTiposLogradouro}
          isDisabled={formik.isSubmitting}
        />
      </div>
      <div className='col-md-6'>
        <FormSelect
          formik={formik}
          name={campoPais}
          inputId={`${idPrefix}-pais`}
          label={t('pais_endereco.label')}
          fetchOptions={OptionsHelper.getOptionsPaises}
          isDisabled={formik.isSubmitting}
        />
      </div>
    </div>
  )
}
